"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invalidName = "Input can only have spaces, letters, numbers, hyphens, '@', and periods.";
// Returns any potential errors in string form
exports.checkValidName = (name) => {
    let regexp = /^[a-zA-Z0-9-@. ]+$/;
    let allErr = "";
    const appendErr = (newErr) => {
        if (allErr != "") {
            allErr += " ";
            allErr += newErr;
        }
        else {
            allErr += newErr;
        }
    };
    if (name) {
        if (name.search(regexp) == -1) {
            appendErr(exports.invalidName);
        }
    }
    return allErr == "" ? undefined : allErr;
};
exports.getUserFullName = (user) => (user.firstName ? user.firstName : "") +
    " " +
    (user.lastName ? user.lastName : "");
exports.displayUserInfo = (user) => exports.getUserFullName(user) +
    " (" +
    (user.username ? user.username : user.id) +
    ")";
exports.parseUsername = (value) => {
    let username = "";
    const parts = value.trim().split(" ");
    if (parts.length >= 3) {
        const usernamePart = parts[parts.length - 1];
        if (usernamePart.length >= 2 &&
            usernamePart.charAt(0) === "(" &&
            usernamePart.charAt(usernamePart.length - 1) === ")") {
            username = usernamePart.substring(1, usernamePart.length - 1);
        }
    }
    return username;
};
